import { CartItem } from "@omni/types/api/cart/bff/shared/cartItem.model";
import { ReactElement } from "react";

import ChangeQuantityCTAVisual from "@/components/CallToActions/ChangeQuantityCTAVisual/changeQuantityCTAVisual.component";
import { CTAActions } from "@/redux/modules/api/data/cart/@types/cart.types";

const changeQuantityCTAVisual = (
    product: CartItem | null,
    action: CTAActions
): ReactElement => {
    const actualQuantity = action.productParameters[1];
    return (
        <ChangeQuantityCTAVisual
            actualQuantity={actualQuantity}
            type={action.type}
            sku={product?.sku}
        />
    );
};

export default changeQuantityCTAVisual;
